export default __webpack_public_path__ + "static/media/kashi-color-flat.6284cee9.png";